import { InjectionToken, Type } from '@angular/core';

export interface AmazonFinanceErpExtension {
  id: string;
  navigationLabel: string;
  navigationIcon: string;
  configurationComponent: Type<unknown>;
}

export const AMAZON_FINANCE_ERP_EXTENSIONS = new InjectionToken<AmazonFinanceErpExtension[]>(
  'AMAZON_FINANCE_ERP_EXTENSIONS'
);
